export const SORT = "SORT";

export const sort = (by) => {
  return {
    type: SORT,
    payload: by,
  };
};
